import { PrimitiveValueObject } from '@/domain/primitiveValueObject';

/**
 * 体調メモ
 */
export class ConditionNote extends PrimitiveValueObject<string> {
  static create(value: string): ConditionNote {
    return new ConditionNote(value);
  }
}
